module.exports = __webpack_public_path__ + "resources/img/mark_27018_lg.b98bc8bd05fcb874e7635469db5057a9.png";